module.exports = __webpack_public_path__ + "static/media/TasklyStyleTile.e32b7641.png";